import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as LocationService from "../../../services/location-service";

// initial state of slice
const initialState = {
    selectedEmployee: null,
    locationData: null,
    selectedDate: new Date().toISOString().split('T')[0],
    status: 'idle',
    error: null,
};

export const getEmployeeLocationData = createAsyncThunk(
    "selectedEmployee/getEmployeeLocationData",
    async (params) => {
        console.log("Params in thunk:", params);
        return LocationService.getEmployeeLocationData(params);
    }
);

const selectedEmployeeSlice = createSlice({
    name: "selectedEmployee",
    initialState,
    reducers: {
        reset: (state) => {
            state.selectedEmployee = null;
            state.status = 'idle';
            state.error = null;
            state.locationData = null;
            state.selectedDate = new Date().toISOString().split('T')[0];
        },
        setSelectedEmployee: (state, action) => {
            state.selectedEmployee = action.payload;
            state.status = 'idle';
            state.error = null;
        },
        setSelectedDate: (state, action) => {
            state.selectedDate = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getEmployeeLocationData.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(getEmployeeLocationData.fulfilled, (state, action) => {
                state.loading = 'succeeded';
                state.error = null;
                state.locationData = action.payload;
            })
            .addCase(getEmployeeLocationData.rejected, (state, action) => {
                state.loading = 'failed';
                state.error = action.error.message;
                state.locationData = null;
            });
    }
});

export const selectSelectedEmployee = (state) => state.selectedEmployee.selectedEmployee;

export const selectLocationData = (state) => state.selectedEmployee.locationData;

export const selectSelectedDate = (state) => state.selectedEmployee.selectedDate;

export const { reset, setSelectedEmployee, setSelectedDate } = selectedEmployeeSlice.actions;
export default selectedEmployeeSlice.reducer;
